<template>
  <v-expansion-panels v-model="detail_panel" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div><v-icon>mdi-account-group</v-icon><span class="headerTitle">{{ labels.bondRiskDetTitle }}</span></div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.bondNo"
                    :label="labels.bondNo"
                    :error-messages="errors.collect('bondNo')"
                    data-vv-name="bondNo"
                    :data-vv-as="labels.bondNo"
                    v-validate="valBondNo"
                    @change="doValBondNo"
                    :loading="bondNoLoading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <cal-picker v-model="mainForm.momUpdDate" :label="labels.momUpdDate" :disabled="true"></cal-picker>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.authName"
                    :label="labels.authName"
                    :error-messages="errors.collect('authName')"
                    data-vv-name="authName"
                    :data-vv-as="labels.authName"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.medPolNo"
                    :label="labels.medPolNo"
                    :error-messages="errors.collect('medPolNo')"
                    data-vv-name="medPolNo"
                    :data-vv-as="labels.medPolNo"
                    v-validate="valMedPolNo"
                    @change="doValMedPolNo"
                    :loading="medPolNoLoading"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <cal-picker v-model="mainForm.medComDate" :label="labels.medComDate" :disabled="true" :loading="medPolNoLoading"></cal-picker>
                </v-flex>
                <v-flex lg4 xs12>
                  <cal-picker v-model="mainForm.medExpDate" :label="labels.medExpDate" :disabled="true" :loading="medPolNoLoading"></cal-picker>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-checkbox class="align-end justify-end" color="primary" :label="labels.exclMomDnld" v-model="mainForm.exclMomDnld"></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-data-table :headers="headers" :items="workerList" class="elevation-1" :loading="loading">
                    <template v-slot:item="row">
                      <tr>
                        <td>{{ row.item.wrkmanNo }}</td>
                        <td>{{ row.item.wrkPerTypeDesc }}</td>
                        <td>{{ row.item.wrkPermNo }}</td>
                        <td>{{ row.item.pPortNo }}</td>
                        <td>{{ row.item.name }}</td>
                        <td style="text-align: center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectWorker(row.item)" :loading="policy.loading">
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.editWorker }}</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="red" text @click.prevent="doPromptRemoveWorker(row.item)" :loading="policy.loading">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.delWorker }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <confirm v-model="promptRemoveWorker" @ok="doRemoveWorker">{{ deleteWorker }}</confirm>
                </v-flex>
                <v-flex xs12>
                  <v-btn text color="primary" dark @click.prevent="doAddWorker" :loading="policy.loading">
                    <v-icon dark left>mdi-plus-box</v-icon>{{ labels.addWorker }}
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel :disabled="disabledWorker">
                      <v-expansion-panel-header>
                        <div>{{ labels.workerTitle }}</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex lg4 xs12>
                                  <v-autocomplete
                                    :items="wrkPerTypeList"
                                    v-model="workerForm.wrkPerType"
                                    data-vv-scope="workerForm"
                                    :label="labels.wrkPerType"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="wrkPerType"
                                    :data-vv-as="labels.wrkPerType"
                                    :error-messages="errors.collect('workerForm.wrkPerType')"
                                    v-validate="'required'"
                                    :loading="loading"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <v-text-field
                                    v-model="workerForm.wrkPermNo"
                                    data-vv-scope="workerForm"
                                    :label="labels.wrkPermNo"
                                    :error-messages="errors.collect('workerForm.wrkPermNo')"
                                    data-vv-name="wrkPermNo"
                                    :data-vv-as="labels.wrkPermNo"
                                    v-validate="valWrkPermNo"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <v-text-field
                                    v-model="workerForm.pPortNo"
                                    data-vv-scope="workerForm"
                                    :label="labels.pPortNo"
                                    :error-messages="errors.collect('workerForm.pPortNo')"
                                    data-vv-name="pPortNo"
                                    :data-vv-as="labels.pPortNo"
                                    v-validate="valpPortNo"
                                    :max="9"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex lg8 xs12>
                                  <v-text-field
                                    v-model="workerForm.name"
                                    data-vv-scope="workerForm"
                                    :label="labels.name"
                                    :error-messages="errors.collect('workerForm.name')"
                                    data-vv-name="name"
                                    :data-vv-as="labels.name"
                                    v-validate="'required|max:60'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <cal-picker
                                    v-model="workerForm.dob"
                                    data-vv-scope="workerForm"
                                    :label="labels.dob"
                                    v-validate="'required'"
                                    :data-vv-as="labels.dob"
                                    data-vv-name="dob"
                                    :error-messages="errors.collect('workerForm.dob')"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <v-text-field
                                    v-model="workerForm.occp"
                                    data-vv-scope="workerForm"
                                    :label="labels.occp"
                                    :error-messages="errors.collect('workerForm.occp')"
                                    data-vv-name="occp"
                                    :data-vv-as="labels.occp"
                                    v-validate="'required|max:60'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <v-autocomplete
                                    :items="genderList"
                                    v-model="workerForm.gender"
                                    data-vv-scope="workerForm"
                                    :label="labels.gender"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="gender"
                                    :data-vv-as="labels.gender"
                                    :error-messages="errors.collect('workerForm.gender')"
                                    v-validate="'required'"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex lg4 xs12>
                                  <v-text-field
                                    v-model="workerForm.nation"
                                    data-vv-scope="workerForm"
                                    :label="labels.nation"
                                    :error-messages="errors.collect('workerForm.nation')"
                                    data-vv-name="workerForm.nation"
                                    :data-vv-as="labels.name"
                                    v-validate="'max:20'"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-btn class="mr-2" color="blue" dark type="submit" :loading="policy.loading" @click.prevent="doSaveWorker">
                                    <v-icon dark left>mdi-content-save</v-icon>{{ labels.save }}
                                  </v-btn>
                                  <v-btn color="red" dark :loading="policy.loading" @click.prevent="doResetWorker">
                                    <v-icon dark left>mdi-refresh</v-icon>{{ labels.reset }}
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-dialog v-model="policy.loading" persistent width="300">
                                <v-card color="primary" dark>
                                  <v-card-text>
                                    Processing...
                                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <confirm v-model="promptWarnBondNo" @ok="doProceedBondNo">{{ warnBondNoMsg }}</confirm>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { parseISO } from 'date-fns'
import { yearDiff } from '@/utils/date'
import { gender } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        bondRiskDetTitle: 'Bond Risk Details',
        // bondNo: 'Insurance Bond No.',
        bondNo: 'Employer NRIC No./Fin No./UEN No.',
        momUpdDate: 'Update MOM Date',
        medPolNo: 'PAI Policy No.',
        medComDate: 'PAI Commencement Date',
        medExpDate: 'PAI Expiry Date',
        delWorker: 'Delete Worker',
        editWorker: 'Edit Worker',
        addWorker: 'Add Worker',
        workerTitle: 'Worker Details',
        wrkPerType: 'Work Permit Type',
        wrkPermNo: 'Work Permit No.',
        // pPortNo: 'Passport No.',
        pPortNo: 'Worker FIN No.',
        name: 'Insured Person',
        dob: 'Date of Birth',
        occp: 'Occupation',
        gender: 'Gender',
        nation: 'Nationality',
        save: 'Save',
        reset: 'Reset',
        authName: 'Authorized Name',
        exclMomDnld: 'Exclude MOM Download'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        seqNo: undefined,
        bondNo: undefined,
        momUpdDate: undefined,
        medPolNo: undefined,
        medComDate: undefined,
        medExpDate: undefined,
        authName: undefined,
        exclMomDnld: undefined
      },
      workerForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        wrkmanNo: undefined,
        wrkPerType: undefined,
        wrkPermNo: undefined,
        pPortNo: undefined,
        name: undefined,
        dob: undefined,
        occp: undefined,
        gender: undefined,
        nation: undefined
      },
      resetWorkerForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        wrkmanNo: undefined,
        wrkPerType: undefined,
        wrkPermNo: undefined,
        pPortNo: undefined,
        name: undefined,
        dob: undefined,
        occp: undefined,
        gender: undefined,
        nation: undefined
      },
      error: {
        bondNo: undefined,
        medPolNo: undefined
      },
      bondNoLoading: false,
      medPolNoLoading: false,
      loading: false,
      headers: [
        { text: 'Seq No.', align: 'left', value: 'wrkmanNo' },
        { text: 'Work Permit Type', value: 'wrkPerTypeDesc' },
        { text: 'Work Permit No.', value: 'wrkPermNo' },
        { text: 'Worker FIN No.', value: 'pPortNo' },
        { text: 'Insured Person', value: 'name' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      workerList: [],
      policy: {
        loading: false
      },
      wrkPerTypeList: [
        {
          label: 'New',
          value: 'N'
        },
        {
          label: 'Renewal',
          value: 'R'
        },
        {
          label: 'Transfer',
          value: 'T'
        }
      ],
      panel: [0],
      detail_panel: [],
      promptRemoveWorker: undefined,
      promptValBondNo: undefined,
      deleteWorker: undefined,
      selectedWorker: undefined,
      promptWarnBondNo: false,
      warnBondNoMsg: undefined,
      selectBondNo: undefined,
      allowBondNo: false,
      getPolMiscEmpyt: false,
      validBondNo: false
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    polMiscWrkman() {
      return this.$store.state.underwriting.policy.polMiscWrkman
    },
    valBondNo() {
      if (this.error.bondNo === undefined) {
        return 'required|max:20'
      } else if (this.allowBondNo !== true) {
        return 'required|max:20|valField:' + this.error.bondNo
      } else {
        return 'required|max:20'
      }
    },
    valMedPolNo() {
      if (this.error.medPolNo === undefined) {
        return 'max:16'
      } else {
        return 'max:16|valField:' + this.error.medPolNo
      }
    },
    disabledWorker() {
      if (this.workerForm.wrkmanNo === undefined) {
        return true
      } else {
        return false
      }
    },
    valWrkPermNo() {
      if (this.workerForm.wrkPermNo === undefined) {
        return 'required|max:10'
      } else {
        if (!this.workerForm.wrkPermNo.substring(0, 1).match(/^-{0,1}\d+$/)) {
          return 'required|max:10|valField:' + 'First character must be number.(10290)'
        } else if (this.workerForm.wrkPermNo.substring(1, 2) !== ' ') {
          return 'required|max:10|valField:' + 'Second character must be space.(10291)'
        } else if (!this.workerForm.wrkPermNo.substring(2, 9).match(/^-{0,1}\d+$/)) {
          return 'required|max:10|valField:' + 'Third to ninth Characters must be number.(10493)'
        } else {
          return 'required|max:10'
        }
      }
    },
    valpPortNo() {
      if (this.workerForm.pPortNo === undefined) {
        return 'required|max:9'
      } else {
        if (!this.workerForm.pPortNo.substring(0, 1).match(/^[A-Za-z]+$/)) {
          return 'required|max:9|valField:First position must be a character'
        } else if (!this.workerForm.pPortNo.substring(1, 8).match(/^[0-9]+$/)) {
          return 'required|max:9|valField:Second to Eight positions must be digit'
        } else if (!this.workerForm.pPortNo.substring(8, 9).match(/^[A-Za-z]+$/)) {
          return 'required|max:9|valField:Ninth positions must be a character'
        }
        return 'required|max:9'
      }
    },
    valDob() {
      if (this.workerForm.dob === undefined) {
        return 'required'
      } else {
        var age = yearDiff(new Date(), this.workerForm.dob)
        if ((this.workerForm.wrkPerType === 'N' || this.workerForm.wrkPerType === 'T') && (age < 23 || age > 50)) {
          return 'required|valField:' + 'Must be between 23 to 50 years old.(10451)'
        } else if (this.workerForm.wrkPerType === 'R' && (age < 23 || age > 60)) {
          return 'required|valField:' + 'Must be between 23 to 60 years old.(10452)'
        } else {
          return 'required'
        }
      }
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function(key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    getNewWrkman() {
      return this.workerList.filter(worker => {
        return worker.newWrkman === true
      })
    }
  },
  methods: {
    doInit() {
      this.getPolBondRisk()
    },
    async getPolBondRisk() {
      const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.getPolBondRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo,
            seqNo: 1
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polMiscEmpyt) {
            this.getPolMiscEmpyt = true
            this.mainForm.polNo = result.data.polMiscEmpyt.data.polNo
            this.mainForm.renCnt = result.data.polMiscEmpyt.data.renCnt
            this.mainForm.endtCnt = result.data.polMiscEmpyt.data.endtCnt
            this.mainForm.riskGrpNo = result.data.polMiscEmpyt.data.riskGrpNo
            this.mainForm.riskNo = result.data.polMiscEmpyt.data.riskNo
            this.mainForm.seqNo = result.data.polMiscEmpyt.data.seqNo
            this.mainForm.bondNo = result.data.polMiscEmpyt.data.bondNo
            this.mainForm.momUpdDate = result.data.polMiscEmpyt.data.momUpdDate
            this.mainForm.medPolNo = result.data.polMiscEmpyt.data.medPolNo
            this.mainForm.medComDate = result.data.polMiscEmpyt.data.medComDate
            this.mainForm.medExpDate = result.data.polMiscEmpyt.data.medExpDate
            this.mainForm.authName = result.data.polMiscEmpyt.data.authName
            this.mainForm.exclMomDnld = result.data.polMiscEmpyt.data.exclMomDnld
            // this.doValBondNo()
          }

          if (result.data.polMiscWrkmanList) {
            this.workerList = []
            const { data } = result.data.polMiscWrkmanList
            await data.map(worker => {
              const convertworker = {
                wrkmanNo: worker.wrkmanNo,
                wrkPerType: worker.wrkPerType,
                wrkPerTypeDesc: this.getWrkPerTypeDesc(worker.wrkPerType),
                wrkPermNo: worker.wrkPermNo,
                pPortNo: worker.pportNo,
                name: worker.name,
                dob: parseISO(worker.dob),
                occp: worker.occp,
                gender: worker.gender,
                nation: worker.nation,
                newWrkman: worker.newWrkman
              }
              this.workerList.push(convertworker)
            })
            if (this.workerList.length > 0) {
              this.doSelectWorker(this.workerList[0])
            }
            // this.doSelectWorker()
          } else {
            this.workerList = []
          }
          this.hideInitLoading()
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    hideInitLoading() {
      // Set parent policy.initLoading to false
      this.$emit('hide-init-loading')
    },
    async doValBondNo() {
      this.error.bondNo = undefined
      this.allowBondNo = false
      this.getPolMiscEmpyt = false
      this.validBondNo = false
      if (this.mainForm.bondNo !== undefined && this.mainForm.bondNo !== '') {
        const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.valBondNo
        if (apiUrl) {
          this.bondNoLoading = true
          try {
            const expand = {
              bondNo: this.mainForm.bondNo,
              polNo: this.polMaster.polNo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.bondNo = undefined
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.doPromptValBondNo(data.messages[0].message)
              this.error.bondNo = data.messages[0].message
            }
          }
          this.bondNoLoading = false
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doValBondNo2() {
      let isPass = false
      if (this.mainForm.bondNo !== undefined && this.mainForm.bondNo !== '') {
        const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.valBondNo
        if (apiUrl) {
          try {
            const expand = {
              bondNo: this.mainForm.bondNo,
              polNo: this.polMaster.polNo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.promptWarnBondNo = false
              this.warnBondNoMsg = undefined
              isPass = true
              this.validBondNo = true
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.promptWarnBondNo = this.getPolMiscEmpyt ? false : this.getPolMiscEmpyt
              this.warnBondNoMsg = data.messages[0].message
              isPass = false
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          isPass = false
        }
        return isPass
      }
    },
    async doValMedPolNo() {
      this.error.medPolNo = undefined
      if (this.mainForm.medPolNo !== undefined && this.mainForm.medPolNo !== '') {
        const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.valMedPolNo
        if (apiUrl) {
          this.medPolNoLoading = true
          try {
            const expand = {
              medPolNo: this.mainForm.medPolNo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.mainForm.medComDate = parseISO(result.data.comDate)
              this.mainForm.medExpDate = parseISO(result.data.expDate)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.error.medPolNo = data.messages[0].message
            }
          }
          this.medPolNoLoading = false
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      } else {
        this.$toast.warning('PAI Policy No. is blank. (10449)')
      }
    },
    async doSelectWorker(data) {
      this.panel = [0]
      this.workerForm.wrkmanNo = data.wrkmanNo
      this.workerForm.wrkPerType = data.wrkPerType
      this.workerForm.wrkPermNo = data.wrkPermNo
      this.workerForm.pPortNo = data.pPortNo
      this.workerForm.name = data.name
      this.workerForm.dob = data.dob
      this.workerForm.occp = data.occp
      this.workerForm.gender = data.gender
      this.workerForm.nation = data.nation

      this.resetWorkerForm.wrkmanNo = this.workerForm.wrkmanNo
      this.resetWorkerForm.wrkPerType = this.workerForm.wrkPerType
      this.resetWorkerForm.wrkPermNo = this.workerForm.wrkPermNo
      this.resetWorkerForm.pPortNo = this.workerForm.pPortNo
      this.resetWorkerForm.name = this.workerForm.name
      this.resetWorkerForm.dob = this.workerForm.dob
      this.resetWorkerForm.occp = this.workerForm.occp
      this.resetWorkerForm.gender = this.workerForm.gender
      this.resetWorkerForm.nation = this.workerForm.nation
    },
    async doPromptRemoveWorker(data) {
      this.selectedWorker = data
      this.deleteWorker = 'Confirm to Delete Workman No. ' + data.wrkmanNo + '?'
      this.promptRemoveWorker = true
    },
    async doPromptValBondNo(data) {
      this.selectedBondNo = this.mainForm.bondNo
      this.warnBondNoMsg = data + '. Confirm to proceed?'
      // this.promptValBondNo = true
      this.promptWarnBondNo = true
    },
    doProceedBondNo() {
      this.promptWarnBondNo = false
      this.allowBondNo = true
    },
    async doAddWorker() {
      const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.addWorker
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.polRisk.polNo,
            renCnt: this.polRisk.renCnt,
            endtCnt: this.polRisk.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.polMiscWrkmanList) {
            this.workerList = []
            const { data } = result.data.polMiscWrkmanList
            data.map(worker => {
              const convertworker = {
                wrkmanNo: worker.wrkmanNo,
                wrkPerType: worker.wrkPerType,
                wrkPerTypeDesc: this.getWrkPerTypeDesc(worker.wrkPerType),
                wrkPermNo: worker.wrkPermNo,
                pPortNo: worker.pportNo,
                name: worker.name,
                dob: worker.dob,
                occp: worker.occp,
                gender: worker.gender,
                nation: worker.nation,
                newWrkman: worker.newWrkman
              }
              this.workerList.push(convertworker)
            })
          } else {
            this.workerList = []
          }

          this.panel = [0]
          this.workerForm.wrkmanNo = this.getNewWrkman[0].wrkmanNo
          this.workerForm.wrkPerType = this.getNewWrkman[0].wrkPerType
          this.workerForm.wrkPermNo = this.getNewWrkman[0].wrkPermNo
          this.workerForm.pPortNo = this.getNewWrkman[0].pPortNo
          this.workerForm.name = this.getNewWrkman[0].name
          this.workerForm.dob = this.getNewWrkman[0].dob
          this.workerForm.occp = this.getNewWrkman[0].occp
          this.workerForm.gender = this.getNewWrkman[0].gender
          this.workerForm.nation = this.getNewWrkman[0].nation

          this.resetWorkerForm.wrkmanNo = this.workerForm.wrkmanNo
          this.resetWorkerForm.wrkPerType = this.workerForm.wrkPerType
          this.resetWorkerForm.wrkPermNo = this.workerForm.wrkPermNo
          this.resetWorkerForm.pPortNo = this.workerForm.pPortNo
          this.resetWorkerForm.name = this.workerForm.name
          this.resetWorkerForm.dob = this.workerForm.dob
          this.resetWorkerForm.occp = this.workerForm.occp
          this.resetWorkerForm.gender = this.workerForm.gender
          this.resetWorkerForm.nation = this.workerForm.nation

          this.policy.loading = false
          this.$toast.success('New Worker Added')
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSaveWorker() {
      this.resetMessages()
      this.$validator.validateAll('workerForm').then(result => {
        if (result) {
          this.policy.loading = true
          if (
            this.mainForm.polNo === undefined &&
            this.mainForm.renCnt === undefined &&
            this.mainForm.endtCnt === undefined &&
            this.mainForm.riskGrpNo === undefined &&
            this.mainForm.riskNo === undefined
          ) {
            this.workerForm.polNo = this.polRisk.polNo
            this.workerForm.renCnt = this.polRisk.renCnt
            this.workerForm.endtCnt = this.polRisk.endtCnt
            this.workerForm.riskGrpNo = this.polRisk.riskGrpNo
            this.workerForm.riskNo = this.polRisk.riskNo
          } else {
            this.workerForm.polNo = this.mainForm.polNo
            this.workerForm.renCnt = this.mainForm.renCnt
            this.workerForm.endtCnt = this.mainForm.endtCnt
            this.workerForm.riskGrpNo = this.mainForm.riskGrpNo
            this.workerForm.riskNo = this.mainForm.riskNo
          }
          if (this.workerForm.wrkmanNo === undefined) {
            this.workerForm.wrkmanNo = 1
          }
          this.doPolMiscWrkmanSave().then(success => {
            if (success) {
              this.initWorkerForm()
              this.displayWorkerList()
              this.$toast.success('Worker Details Successfully Saved')
            } else {
              this.$toast.error('Worker Details Save Failed')
            }
            this.policy.loading = false
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPolMiscWrkmanSave() {
      try {
        if (
          this.mainForm.polNo === undefined &&
          this.mainForm.renCnt === undefined &&
          this.mainForm.endtCnt === undefined &&
          this.mainForm.riskGrpNo === undefined &&
          this.mainForm.riskNo === undefined
        ) {
          this.workerForm.polNo = this.polRisk.polNo
          this.workerForm.renCnt = this.polRisk.renCnt
          this.workerForm.endtCnt = this.polRisk.endtCnt
          this.workerForm.riskGrpNo = this.polRisk.riskGrpNo
          this.workerForm.riskNo = this.polRisk.riskNo
        } else {
          this.workerForm.polNo = this.mainForm.polNo
          this.workerForm.renCnt = this.mainForm.renCnt
          this.workerForm.endtCnt = this.mainForm.endtCnt
          this.workerForm.riskGrpNo = this.mainForm.riskGrpNo
          this.workerForm.riskNo = this.mainForm.riskNo
        }
        const result = await this.$store.dispatch('savePolMiscWrkman', this.workerForm)
        if (result) {
          return true
        } else {
          return false
        }
      } catch (err) {
        return false
      }
    },
    doResetWorker() {
      this.workerForm.wrkmanNo = this.resetWorkerForm.wrkmanNo
      this.workerForm.wrkPerType = this.resetWorkerForm.wrkPerType
      this.workerForm.wrkPermNo = this.resetWorkerForm.wrkPermNo
      this.workerForm.pPortNo = this.resetWorkerForm.pPortNo
      this.workerForm.name = this.resetWorkerForm.name
      this.workerForm.dob = this.resetWorkerForm.dob
      this.workerForm.occp = this.resetWorkerForm.occp
      this.workerForm.gender = this.resetWorkerForm.gender
      this.workerForm.nation = this.resetWorkerForm.nation
    },
    initWorkerForm() {
      this.panel = []

      this.workerForm.wrkmanNo = undefined
      this.workerForm.wrkPerType = undefined
      this.workerForm.wrkPermNo = undefined
      this.workerForm.pPortNo = undefined
      this.workerForm.name = undefined
      this.workerForm.dob = undefined
      this.workerForm.occp = undefined
      this.workerForm.gender = undefined
      this.workerForm.nation = undefined

      this.resetWorkerForm.wrkmanNo = this.workerForm.wrkmanNo
      this.resetWorkerForm.wrkPerType = this.workerForm.wrkPerType
      this.resetWorkerForm.wrkPermNo = this.workerForm.wrkPermNo
      this.resetWorkerForm.pPortNo = this.workerForm.pPortNo
      this.resetWorkerForm.name = this.workerForm.name
      this.resetWorkerForm.dob = this.workerForm.dob
      this.resetWorkerForm.occp = this.workerForm.occp
      this.resetWorkerForm.gender = this.workerForm.gender
      this.resetWorkerForm.nation = this.workerForm.nation
    },
    displayWorkerList() {
      this.workerList = []
      if (this.polMiscWrkman.polMiscWrkmanList) {
        this.workerList = []
        const { data } = this.polMiscWrkman.polMiscWrkmanList
        data.map(worker => {
          const convertworker = {
            wrkmanNo: worker.wrkmanNo,
            wrkPerType: worker.wrkPerType,
            wrkPerTypeDesc: this.getWrkPerTypeDesc(worker.wrkPerType),
            wrkPermNo: worker.wrkPermNo,
            pPortNo: worker.pportNo,
            name: worker.name,
            dob: parseISO(worker.dob),
            occp: worker.occp,
            gender: worker.gender,
            nation: worker.nation,
            newWrkman: worker.newWrkman
          }
          this.workerList.push(convertworker)
        })
      } else {
        this.workerList = []
      }
    },
    async doRemoveWorker(data) {
      const apiUrl = this.$store.state.underwriting.policyBondRiskSettings.menu.delWorker
      if (apiUrl) {
        try {
          this.policy.loading = true
          const expand = {
            polNo: this.mainForm.polNo,
            renCnt: this.mainForm.renCnt,
            endtCnt: this.mainForm.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo,
            riskNo: this.mainForm.riskNo,
            wrkmanNo: this.selectedWorker.wrkmanNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data.polMiscWrkmanList) {
            this.workerList = []
            const { data } = result.data.polMiscWrkmanList
            data.map(worker => {
              const convertworker = {
                wrkmanNo: worker.wrkmanNo,
                wrkPerType: worker.wrkPerType,
                wrkPerTypeDesc: this.getWrkPerTypeDesc(worker.wrkPerType),
                wrkPermNo: worker.wrkPermNo,
                pPortNo: worker.pportNo,
                name: worker.name,
                dob: worker.dob,
                occp: worker.occp,
                gender: worker.gender,
                nation: worker.nation,
                newWrkman: worker.newWrkman
              }
              this.workerList.push(convertworker)
            })
          } else {
            this.workerList = []
          }
          this.panel = []
          this.initWorkerForm()
          this.policy.loading = false
          this.$toast.success('Worker Details Successfully Deleted')
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getWrkPerTypeDesc(wrkPerType) {
      if (wrkPerType === 'N') {
        return 'New'
      } else if (wrkPerType === 'R') {
        return 'Renewal'
      } else if (wrkPerType === 'T') {
        return 'Transfer'
      } else {
        return ''
      }
    },
    async doPolMiscEmpytSave() {
      try {
        if (
          this.mainForm.polNo === undefined &&
          this.mainForm.renCnt === undefined &&
          this.mainForm.endtCnt === undefined &&
          this.mainForm.riskGrpNo === undefined &&
          this.mainForm.riskNo === undefined
        ) {
          this.mainForm.polNo = this.polRisk.polNo
          this.mainForm.renCnt = this.polRisk.renCnt
          this.mainForm.endtCnt = this.polRisk.endtCnt
          this.mainForm.riskGrpNo = this.polRisk.riskGrpNo
          this.mainForm.riskNo = this.polRisk.riskNo
        }
        const result = await this.$store.dispatch('savePolMiscEmpyt', this.mainForm)
        if (result) {
          return true
        } else {
          return false
        }
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyBondRiskSettings.init !== 1) {
      this.$store.dispatch('policyBondRiskInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin]
}
</script>

<style></style>
